import ReportingFileUpload from 'Components/ReportingFileUpload'
import React, { useState } from 'react'
import { Link } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap'
interface ImportUsersType {
    setState: (state: boolean) => void;
}
const ImportUsersPopup = ({ setState }: ImportUsersType) => {
    /** State variables start */
    const [file, setFile] = useState<Array<File>>([]);
    const [refreshKey, setRefreshKey] = useState(0);
    /** State variables end */
    return (
        <React.Fragment>
            <div className='p-2'>
                <h6>Steps :</h6>
                <ol>
                    <li>Download template file of user.</li>
                    <li>Fill  all valid data in the given fields.</li>
                    <li>Do not modify any column heading or add extra columns.</li>
                    <li>Upload valid .xlsx-template file.</li>
                </ol>
                <Row className='mt-0'>
                    <ReportingFileUpload
                        setFile={setFile}
                        file={file}
                        deleteURL={''}
                        invalidateQuery={''}
                        deleteID={0}
                        fileUploadStatus={false}
                        refreshKey={refreshKey}
                        title=""
                        DeleteFileObj={null}
                        fileURL=''
                        setRefreshKey={setRefreshKey}
                        index={2}
                        sm={4}
                        fileTypes={{
                            'application/vnd.ms-excel': ['.xls'],
                            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
                        }}
                        fileTypesError={'Only .xls & .xlsx files are allowed!'}
                    />
                </Row>
            </div>
            <Row className='d-flex ms-auto justify_right p-2'>
                <Col>
                    <Button color='danger' onClick={() => { setState(false) }}>Cancel</Button>
                </Col>
                <Col>
                    <Link className="btn_size_cstm mr-1 btn btn-primary" to="/users/imports">
                        ok
                    </Link>
                </Col>
            </Row>
        </React.Fragment>
    )
}

export default ImportUsersPopup